import { style } from "typestyle";

export const imageWrapper = style({
  width: "6rem",
  height: "6rem",
  display: "flex",
  borderRadius: "9px",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "12px 0",
});
